import { useCallback, useMemo } from 'react';

import { VacanciesRoute } from '../../../../routers/AppRouter/routes';
import { VacancyTo } from '../../../../types/routes.types';
import { useGetJobId } from '../../useGetJobId';
import { useAutoRedirect } from '../useAutoRedirect';

export const useAutoRedirectVacancyDetails = (): void => {
  const jobId = useGetJobId();
  const redirectCondition = useCallback(() => !!jobId, [jobId]);
  const redirectRoute: VacancyTo = useMemo(
    () => ({ pathname: VacanciesRoute.VACANCY_DETAILS, queryParams: { job: jobId || '' } }),
    [jobId]
  );

  useAutoRedirect(redirectRoute, redirectCondition);
};
